module.exports = __webpack_public_path__ + "static/c-sharp-3d8e8bac0364918b524c525da1b7fc8e.png";